<template>
    <div :class="{ eventTaskDetail: newStyle === '0', newEventTaskDetail: newStyle === '1' }">
        <YScroll style="height: 100%">
            <div style="padding-left: 1.7vw">
                <div class="detail-top">| &nbsp; {{ $t('event.taskDetail.basicInfo') }}</div>
                <el-form
                    :model.sync="taskDetailData1"
                    ref="formDetailData"
                    style="font-size: 10px"
                    label-width="120px"
                    class="detail-ruleForm-read"
                >
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.taskName')">
                                <p class="text-left" :title="taskDetailData1.taskName">
                                    {{ taskDetailData1.taskName }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.taskStatus')">
                                <p class="text-left" :title="taskDetailData1.taskStatus">
                                    {{ taskDetailData1.taskStatus }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.taskNumber')">
                                <p class="text-left" :title="taskDetailData1.taskNumber">
                                    {{ taskDetailData1.taskNumber }}
                                </p>
                                <!-- {{taskDetailData1.taskNumber}} -->
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.exeType')">
                                <p class="text-left">
                                    {{
                                        taskDetailData1.taskexeType == '1'
                                            ? $t('event.taskDetail.dock')
                                            : $t('event.taskDetail.manual')
                                    }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.exeTime')">
                                <p class="text-left" :title="taskDetailData1.taskexeTime">
                                    {{ taskDetailData1.taskexeTime }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.assocService')">
                                <p class="text-left" :title="getTaskserveName(taskDetailData1)">
                                    {{
                                        taskDetailData1.assocService &&
                                        taskDetailData1.assocService.length > 0
                                            ? taskDetailData1.assocService[0].serviceName
                                            : ''
                                    }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.route')">
                                <p class="text-left" :title="taskDetailData1.route">
                                    {{ taskDetailData1.route }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="this.taskDetailData1.taskexeType === '2'">
                            <el-form-item :label="$t('event.taskDetail.mountedDevice')">
                                <p class="text-left" :title="taskDetailData1.taskEquipment">
                                    {{ taskDetailData1.taskEquipment }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="this.taskDetailData1.taskexeType === '2'">
                            <el-form-item :label="$t('event.taskDetail.drone')">
                                <p class="text-left" :title="taskDetailData1.taskAir">
                                    {{ taskDetailData1.taskAir }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8" v-if="this.taskDetailData1.taskexeType === '2'">
                            <el-form-item :label="$t('event.taskDetail.pilot')">
                                <p class="text-left" :title="taskDetailData1.taskDriver">
                                    {{ taskDetailData1.taskDriver }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$t('event.taskDetail.remark')">
                                {{ taskDetailData1.remark }}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-row>
                        <el-col :span="12">
                            <el-form-item label="终止原因">
                                <p class="text-left">{{ taskDetailData1.stopReason }}</p>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                </el-form>
            </div>
            <div style="padding-left: 1.7vw">
                <div class="detail-top">| &nbsp; {{ $t('event.taskDetail.flightInfo') }}</div>
                <el-form
                    :model.sync="taskDetailData1"
                    ref="formDetailData"
                    style="font-size: 10px"
                    label-width="120px"
                    class="detail-ruleForm-read"
                >
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.sorties')">
                                <p class="text-left">
                                    {{ taskDetailData1.flightSorties }}
                                    {{
                                        taskDetailData1.flightSorties
                                            ? $t('event.taskDetail.sortieUnit')
                                            : ''
                                    }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.totalDistance')">
                                <p class="text-left">
                                    {{ taskDetailData1.flightDistance }}
                                    {{ taskDetailData1.flightDistance ? 'km' : '' }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.totalDuration')">
                                <p class="text-left">
                                    {{ taskDetailData1.flightDuration }}
                                    {{ taskDetailData1.flightDuration ? ' h' : '' }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.totalArea')">
                                <p class="text-left">
                                    {{ taskDetailData1.flightArea }}
                                    {{ taskDetailData1.flightArea ? 'km²' : '' }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.avgAltitude')">
                                <p class="text-left">
                                    {{ taskDetailData1.flightAltitude }}
                                    {{ taskDetailData1.flightAltitude ? 'm' : '' }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.avgSpeed')">
                                <p class="text-left">
                                    {{ taskDetailData1.flightSpeed }}
                                    {{ taskDetailData1.flightSpeed ? 'm/s' : '' }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.startExeTime')">
                                <p class="text-left" :title="taskDetailData1.actStartTime">
                                    {{ taskDetailData1.actStartTime }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.endExeTime')">
                                <p class="text-left" :title="taskDetailData1.actEndTime">
                                    {{ taskDetailData1.actEndTime }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div style="padding-left: 1.7vw">
                <div class="detail-top">| &nbsp; {{ $t('event.taskDetail.serviceInfo') }}</div>
                <el-form
                    :model.sync="servData"
                    ref="formDetailData"
                    style="font-size: 10px"
                    label-width="120px"
                    class="detail-ruleForm-read"
                >
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceName')">
                                <p class="text-left" :title="servData.serName">
                                    {{ servData.serName }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceProject')">
                                <p class="text-left" :title="servData.serProject">
                                    {{ servData.serProject }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceOrderNo')">
                                <p class="text-left" :title="servData.serListNum">
                                    {{ servData.serListNum }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.applyUnit')">
                                <p class="text-left" :title="servData.serApplyUnit">
                                    {{ servData.serApplyUnit }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.applyTime')">
                                <p class="text-left" :title="servData.serApplyTime">
                                    {{ servData.serApplyTime }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.applicant')">
                                <p class="text-left" :title="servData.serApplicant">
                                    {{ servData.serApplicant }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceStartTime')">
                                <p class="text-left" :title="servData.serStartTime">
                                    {{ servData.serStartTime }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceEndTime')">
                                <p class="text-left" :title="servData.serEndTime">
                                    {{ servData.serEndTime }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.type')">
                                <p class="text-left" :title="servData.serType">
                                    {{ servData.serType }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceFrequency')">
                                <p class="text-left" :title="servData.serfrequency">
                                    {{ servData.serfrequency }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceLocation')">
                                <p class="text-left" :title="servData.serLocation">
                                    {{ servData.serLocation }}
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('event.taskDetail.serviceScope')">
                                <p class="text-left" :title="servData.serScope">
                                    {{ servData.serScope }}
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-form-item :label="$t('event.taskDetail.serviceRequire')">
                            <p class="text-left-all">{{ servData.serRequire }}</p>
                        </el-form-item>
                    </el-row>
                </el-form>
            </div>
            <!-- <div style="  padding-left: 1.7vw">
            <div  class="detail-top">| &nbsp; 视频信息</div>
            <el-form
                :model.sync="taskDetailData1"
                ref="formDetailData"
                style="font-size: 10px"
                label-width="120px"
                class="detail-ruleForm-read"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="第三视角">
                            <p class="text-left">{{taskDetailData.camera}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="rtmpt 推流地址">
                            <p class="text-left">{{taskDetailData.camera}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="webrtc 地址">
                            <p class="text-left">{{taskDetailData.camera}}</p>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="dvr 地址">
                            <p class="text-left">{{taskDetailData.dvr}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="flv 地址">
                            <p class="text-left">{{taskDetailData.flv}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="hls 地址">
                            <p class="text-left">{{taskDetailData.hls}}</p>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div> -->
        </YScroll>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';

import api from '@/page/taskPage/api.js';
import CustomMarquee from '@/page/mainPage/components/CustomMarquee/CustomMarquee.vue';

export default {
    components: { YScroll },
    props: {
        taskId: {
            type: String,
            default: '',
        },
        newStyle: {
            type: String,
            default: '0',
        },
    },
    data() {
        return {
            taskDriverArray: [],
            AirArray: [],
            AirexeType: [],
            Equipment: [],
            routeList: [],
            assocServiceArr: [],
            siteArray: [],
            ImplementWayArray: [],
            serfrequencyList: [], // 服务频次集合
            serTyleList: [], // 服务类型集合
            loading: true,
            taskDetailData: {
                taskNumber: '', // 任务编号
                taskName: '', // 任务名称
                taskStatus: 1, // 状态
                route: '', // 航线
                site: '', // 站点
                taskexeTime: '', // 执行时间
                taskexeType: '', // 执行方式
                assocService: '', // 关联服务
                taskAir: '', // 无人机
                taskDriver: '', // 驾驶员
                taskEquipment: '', // 任务关联设备
                remark: '', // 备注
                flightDistance: 0, // 飞行距离
                flightSorties: '', // 飞行架次
                flightArea: '', // 飞行面积
                flightAltitude: '', // 平均高度
                flightDuration: '', // 飞行时长
                flightSpeed: '', // 平均速度
                actStartTime: '',
                actEndTime: '', // 实际结束执行时间
                camera: '', // 第三视角播放地址
                rtmp: '', // 云推流地址
                webrtc: '', // webrtc云直播播放地址
                hls: '', // hls云直播地址
                flv: '', // flv云直播地址
                dvr: '', // 外部视频存储播放地址
            },
            servData: {
                // 关联服务信息
                serName: '', // 服务名称
                serProject: '', // 服务项目
                serListNum: '', // 服务单编号
                serApplyUnit: '', // 申请单位
                serApplyTime: '', // 申请时间
                serApplicant: '', // 申请人
                serStartTime: '', // 服务开始时间
                serEndTime: '', // 服务结束时间
                serType: '', // 类型
                serfrequency: '', // 服务频次
                serLocation: '', // 服务位置
                serScope: '', // 服务范围
                serRequire: '', // 服务要求
            },
            taskDetailData1: {
                taskNumber: '',
                taskName: '',
                taskStatus: 1,
                route: '',
                site: '',
                taskexeTime: '',
                taskexeType: '',
                assocService: '',
                taskAir: '',
                taskDriver: '',
                taskEquipment: '',
                remark: '',
                flightDistance: 0,
                flightSorties: '',
                flightArea: '',
                flightAltitude: '',
                flightDuration: '',
                flightSpeed: '',
                actStartTime: '',
                actEndTime: '',
            },
        };
    },
    mounted() {
        this.getAddTaskObj();
        this.getserviceData('dict_service_frequency_unit'); // 服务频次
        this.getserviceTypeData('dict_service_type'); // 服务频次
        this.$props.taskId && this.getTaskDetail();
    },
    watch: {
        taskId: {
            handler(val) {
                val && this.getTaskDetail();
            },
        },
    },
    methods: {
        select() {},
        getTaskserveName(item) {
            return item.assocService && item.assocService.length > 0
                ? item.assocService[0].serviceName
                : '';
        },
        getTaskDetail() {
            api.getTaskDetails({ id: this.taskId })
                .run()
                .then((data) => {
                    console.log(data, '任务详情basic');
                    // 编辑页面驾驶员
                    let dirverList = [];
                    // 查看页面驾驶员
                    let driverLists = [];
                    let taskEquipmentList = [];
                    let taskEquipmentLists = [];
                    if (data.deviceList !== undefined && data.deviceList.length >= 1) {
                        data.deviceList.forEach((k) => {
                            taskEquipmentList.push(k.deviceId);
                            taskEquipmentLists.push(k.deviceName);
                        });
                    }
                    if (data.driverList !== undefined && data.driverList.length >= 1) {
                        data.driverList.forEach((k) => {
                            dirverList.push(k.driverId);
                            driverLists.push(k.driverName);
                        });
                    }
                    this.taskDetailData1 = {
                        taskName: data.name,
                        route: data.routeName,
                        assocService: data.taskServiceList,
                        site: data.siteId,
                        taskexeTime: data.executionTime,
                        taskexeType: data.model,
                        taskAir: data.uavName,
                        taskDriver: driverLists && driverLists.length > 0 ? driverLists.join(',') : '',
                        taskEquipment:
                            taskEquipmentLists && taskEquipmentLists.length > 0
                                ? taskEquipmentLists.join(',')
                                : '',
                        remark: data.remark,
                        taskNumber: data.code,
                        flightDistance: data.flightDistance,
                        flightSorties: data.flightSorties,
                        flightArea: data.flightArea,
                        flightAltitude: data.flightAltitude,
                        flightDuration: data.flightDuration,
                        flightSpeed: data.flightSpeed,
                        actStartTime: data.actStartTime,
                        actEndTime: data.actEndTime,
                        stopReason: data.stopReason,
                        taskStatus: this.getStatus(data),
                    };
                    // 单个关联服务详情
                    if (data.taskServiceList && data.taskServiceList.length > 0) {
                        let startTime = data.taskServiceList[0].startDate.substring(0, 10);
                        let endTime = data.taskServiceList[0].endDate.substring(0, 10);
                        this.servData = {
                            serName: data.taskServiceList[0].serviceName, // 服务名称
                            serProject: data.taskServiceList[0].itemName, // 服务项目
                            serListNum: data.taskServiceList[0].no, // 服务单编号
                            serApplyUnit: data.taskServiceList[0].organName, // 申请单位
                            serApplyTime: data.taskServiceList[0].applictionTime, // 申请时间
                            serApplicant: data.taskServiceList[0].accountName, // 申请人
                            serStartTime: startTime, // 服务开始时间
                            serEndTime: endTime, // 服务结束时间
                            serLocation: data.taskServiceList[0].location, // 服务位置
                            serScope:
                                data.taskServiceList[0].area
                                && JSON.parse(data.taskServiceList[0].area)[0].name, // 服务范围
                            serRequire: data.taskServiceList[0].remark, // 服务要求
                        };
                        this.getServDrequency(
                            data.taskServiceList[0].frequency,
                            data.taskServiceList[0].frequencyUnit,
                        );
                        this.getTypeData(data.taskServiceList[0].servicecType);
                    } else {
                        this.servData = {
                            serName: '', // 服务名称
                            serProject: '', // 服务项目
                            serListNum: '', // 服务单编号
                            serApplyUnit: '', // 申请单位
                            serApplyTime: '', // 申请时间
                            serApplicant: '', // 申请人
                            serStartTime: '', // 服务开始时间
                            serEndTime: '', // 服务结束时间
                            serLocation: '', // 服务位置
                            serScope: '', // 服务范围
                            serRequire: '', // 服务要求
                        };
                    }
                });
        },
        // 服务频次
        getserviceData(w) {
            let obj = {
                ident: w,
            };
            api.getSysDict(obj)
                .run()
                .then((k) => {
                    this.serfrequencyList = k;
                });
        },
        getServDrequency(e1, e2) {
            let res = this.serfrequencyList.filter((item) => item.vals === e2);
            this.servData.serfrequency = this.$t('event.taskDetail.frequencyValue', {
                count: e1,
                unit: res[0].text,
            });
        },
        getTypeData(el) {
            let res = this.serTyleList.filter((item) => item.vals === el);
            this.servData.serType = res && `${res[0].text}`;
        },
        getserviceTypeData(w) {
            let obj = {
                ident: w,
            };
            api.getSysDict(obj)
                .run()
                .then((k) => {
                    this.serTyleList = k;
                });
        },
        getStatus(data) {
            switch (data.taskStatus) {
                case '1':
                    return this.$t('event.taskDetail.statusPending');
                case '2':
                    return this.$t('event.taskDetail.statusExecuting');
                case '3':
                    return this.$t('event.taskDetail.statusExecuted');
                case '4':
                    return this.$t('event.taskDetail.statusResultProcessing');
                case '5':
                    return this.$t('event.taskDetail.statusFinished');
                case '6':
                    return this.$t('event.taskDetail.statusTerminated');
                default:
                    return '';
            }
        },
        async addTask() {
            let devic = '';
            let driver = '';
            let ser = '';
            let add = false;
            if (this.taskDetailData.taskDriver && this.taskDetailData.taskDriver.length >= 1) {
                this.taskDetailData.taskDriver.forEach((item) => {
                    driver += `${item},`;
                });
            } else {
                driver = '';
            }
            if (this.taskDetailData.taskEquipment && this.taskDetailData.taskEquipment.length >= 1) {
                this.taskDetailData.taskEquipment.forEach((item) => {
                    devic += `${item},`;
                });
            } else {
                devic = '';
            }
            ser = `${this.taskDetailData.assocService},`;
            let obj = {
                name: this.taskDetailData.taskName,
                model: this.taskDetailData.taskexeType,
                uavId: this.taskDetailData.taskAir,
                routeId: this.taskDetailData.route,
                driverList: driver,
                deviceList: devic,
                taskServiceList: ser,
                remark: this.taskDetailData.remark,
                executionTime: this.taskDetailData.taskexeTime,
                siteId: this.taskDetailData.site,
            };
            if (this.taskDetailData.taskName === '' || this.taskDetailData.route === '') {
                if (this.taskDetailData.taskexeType === '2') {
                    add = false;
                    this.$message.error(this.$t('event.taskDetail.fillTaskInfo'));
                }
                if (this.taskDetailData.site === '' && this.taskDetailData.taskexeType === '1') {
                    add = false;
                    this.$message.error(this.$t('event.taskDetail.fillTaskInfo'));
                } else {
                    add = true;
                }
            } else {
                add = true;
            }
            if (add) {
                // this.backSave();
                await api
                    .addTask(obj)
                    .run()
                    .then((data) => {
                        if (data) {
                            this.$message.success(this.$t('event.taskDetail.addTaskSuccess'));
                            this.$emit('add');
                        }
                        // window.location.reload();
                    });
            }
        },
        async getAddTaskObj() {
            let obj = {
                ident: 'dict_task_model',
            };
            await api
                .getSysDict(obj)
                .run()
                .then((res) => {
                    this.AirexeType = res;
                });
            await api
                .getDrone()
                .run()
                .then((v) => {
                    this.AirArray = v;
                });
            await api
                .getDriver()
                .run()
                .then((v) => {
                    this.taskDriverArray = v;
                });
            await api
                .getListPayload()
                .run()
                .then((v) => {
                    this.Equipment = v;
                });
            await api
                .getRouteList({})
                .run()
                .then((v) => {
                    this.routeList = v;
                });
            await api
                .getServiceList()
                .run()
                .then((res) => {
                    this.assocServiceArr = res;
                });
            // 站点
            await api
                .getSiteList()
                .run()
                .then((res) => {
                    this.siteArray = res;
                });
            await api
                .getSysDict(obj)
                .run()
                .then((res) => {
                    this.ImplementWayArray = res;
                });
        },
    },
    beforeDestory() {
        this.taskDetailData1 = {};
        this.taskDetailData = {};
    },
};
</script>

<style lang="scss">
.eventTaskDetail {
    // max-height: 600px;
    // width: 100%;
    // overflow-y: auto;
    width: calc(100% - 0px);
    height: 480px;
    .detail-top {
        position: relative;
        top: 24px;
        text-align: left;
        height: 24px;
        color: #000;
    }
    .detail-ruleForm-read {
        color: #000;
        text-align: center;
        margin-top: 20px;
        // margin: 24px 8vw 0 6vw;
        .text-left {
            max-width: 95%;
            text-align: left;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .text-left-all {
            min-width: 200px;
            text-align: left;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .el-form-item__label {
            color: #000;
        }
        .el-input--prefix .el-input__inner {
            padding-left: 15px;
        }
        .not-left {
            padding: 0 !important;
        }
        .el-icon-time:before {
            display: none;
        }
        .el-icon-arrow-up:before {
            display: none;
        }
        .el-input__inner {
            background: #03053d;
            border: none;
            opacity: 1;
            color: #49f0fd;
        }
        .el-textarea__inner {
            background: #03053d;
            opacity: 1;
            border: none;
            color: #fff;
        }
    }
}
.newEventTaskDetail {
    // max-height: 600px;
    // width: 100%;
    // overflow-y: auto;
    width: calc(100% - 0px);
    height: 480px;
    .detail-top {
        position: relative;
        top: 24px;
        text-align: left;
        height: 24px;
        color: #49f0fd;
    }
    .detail-ruleForm-read {
        color: #fff;
        text-align: center;
        margin-top: 20px;
        // margin: 24px 8vw 0 6vw;
        .text-left {
            max-width: 200px;
            text-align: left;
            color: #fff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .text-left-all {
            min-width: 200px;
            text-align: left;
            color: #49f0fd;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .el-form-item__label {
            color: rgba(255, 255, 255, 0.7);
        }
        .el-input--prefix .el-input__inner {
            padding-left: 15px;
        }
        .not-left {
            padding: 0 !important;
        }
        .el-icon-time:before {
            display: none;
        }
        .el-icon-arrow-up:before {
            display: none;
        }
        .el-input__inner {
            background: #03053d;
            border: none;
            opacity: 1;
            color: #49f0fd;
        }
        .el-textarea__inner {
            background: #03053d;
            opacity: 1;
            border: none;
            color: #fff;
        }
    }
}
</style>
<style lang="scss" scoped>
::-webkit-scrollbar {
    width: 5px;
    /*滚动条宽度*/
    background-color: transparent;
}
.taskContent {
    &:hover {
        &::-webkit-scrollbar-thumb {
            background-color: rgba(144, 147, 153, 0.3);
        }
    }
}
::-webkit-scrollbar-thumb {
    /*滚动条的内阴影*/
    border-radius: 10px;
    /*滚动条的圆角*/
    background-color: transparent;
    /*滚动条的背景颜色*/
}
</style>
